import { useState, useEffect } from 'react';

function detectZoomLevel() {
  const ratio = window.devicePixelRatio || 1;
  const zoom = Math.round(ratio * 100);
  return zoom;
}

export function useZoomLevel() {
  const [zoomLevel, setZoomLevel] = useState(100);

  useEffect(() => {
    const updateZoom = () => {
      const zoom = detectZoomLevel();
      setZoomLevel(zoom);
    };

    updateZoom();
    window.addEventListener('resize', updateZoom);

    return () => {
      window.removeEventListener('resize', updateZoom);
    };
  }, []);

  return zoomLevel;
}
